// Canonical footer newsletter handler. The snippet owns the markup; this asset
// owns the submit flow so there is one behavior to keep in sync and audit.
(function () {
  'use strict';

  var SUPABASE_URL = 'https://qdyfqwkainxqnxjwslsb.supabase.co';
  var ANON_KEY = 'sb_publishable__91WMXmO3Nc1vICQU-vuIQ_2ZtIWZ4y';

  function trackNewsletter(eventKey, properties) {
    var analytics = window.SnowcubesAnalytics;
    var eventName = analytics && analytics.EVENTS && analytics.EVENTS[eventKey];
    if (!eventName || typeof analytics?.track !== 'function') return;
    analytics.track(eventName, properties || {});
  }

  function setMessage(message, color, messageNode) {
    if (!messageNode) return;
    messageNode.textContent = message;
    messageNode.style.color = color || '';
    messageNode.style.display = 'block';
  }

  function init() {
    var forms = document.querySelectorAll('[data-newsletter-ajax]');

    forms.forEach(function (form) {
      if (form.getAttribute('data-newsletter-bound') === 'true') return;

      var msg = form.querySelector('[data-newsletter-msg]');
      var input = form.querySelector('[name=email]');
      var btn = form.querySelector('button[type=submit]');
      var btnLabel = btn ? btn.querySelector('[data-newsletter-button-label]') : null;
      if (!input) return;

      form.setAttribute('data-newsletter-bound', 'true');
      form.addEventListener('submit', async function (e) {
        e.preventDefault();
        var startedAt = Date.now();
        var email = (input.value || '').trim().toLowerCase();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          setMessage('Enter a valid email address.', '#c44', msg);
          trackNewsletter('NEWSLETTER_SIGNUP_FAILED', {
            source: 'storefront_form',
            failure_class: 'invalid_email'
          });
          return;
        }

        if (btn) {
          btn.disabled = true;
          if (btnLabel) btnLabel.textContent = 'Submitting';
          else btn.textContent = '...';
        }
        if (msg) {
          msg.textContent = '';
          msg.style.display = 'none';
        }

        try {
          var res = await fetch(SUPABASE_URL + '/rest/v1/rpc/signup_subscriber', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              apikey: ANON_KEY,
              Authorization: 'Bearer ' + ANON_KEY
            },
            body: JSON.stringify({ p_email: email, p_source: 'storefront_form' })
          });

          if (res.ok) {
            setMessage("You're on the kitchen notes list. We'll write about new flavors and what's happening in the kitchen.", '', msg);
            input.value = '';
            // Do NOT send the raw email as an event property (PII).
            trackNewsletter('NEWSLETTER_SIGNUP', {
              source: 'storefront_form',
              latency_ms: Date.now() - startedAt
            });
          } else {
            setMessage("We couldn't save your email. Please try again.", '#c44', msg);
            trackNewsletter('NEWSLETTER_SIGNUP_FAILED', {
              source: 'storefront_form',
              failure_class: res.status >= 500 ? 'server_error' : 'request_rejected',
              latency_ms: Date.now() - startedAt
            });
          }
        } catch (err) {
          setMessage("We couldn't reach the kitchen notes form. Check your connection and try again.", '#c44', msg);
          trackNewsletter('NEWSLETTER_SIGNUP_FAILED', {
            source: 'storefront_form',
            failure_class: 'network_error',
            latency_ms: Date.now() - startedAt
          });
        }

        if (btn) {
          btn.disabled = false;
          if (btnLabel) btnLabel.textContent = 'Subscribe';
          else btn.textContent = 'Subscribe';
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
